import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    performanceDashboard: {
        id: 'iaso.polio.title.performanceDashboard',
        defaultMessage: 'Performance dashboard',
    },
    followLinkBelow: {
        id: 'iaso.polio.title.followLinkBelow',
        defaultMessage: "If the page doesn't redirect, follow the link below",
    },
});

export default MESSAGES;
